const normalizeString = (str: string): string => {
  str = str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
  str = str.replace(/\s/g, '');
  str = str.replaceAll('_', '');
  return str;
};

const normalizeStringFull = (str: string): string => {
  return str
    .normalize('NFD') // Normaliza para decompor caracteres acentuados
    .replace(/[\u0300-\u036f]/g, '') // Remove marcas de acentuação
    .toLowerCase() // Converte para minúsculas
    .replace(/[^a-z0-9]/g, ''); // Remove qualquer caractere que não seja letra ou número
};

export { normalizeString, normalizeStringFull };
